import { MenuItem } from 'primeng/api';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { ApiV6Service } from '@service/apiv6.service';
import { MessagesService } from '@core/_services/messages.service';

@Component({
    selector: 'app-add-editors',
    templateUrl: './add-editors.component.html',
    styleUrls: ['./add-editors.component.scss'],
})
export class AddEditorsComponent implements OnInit {

    @Input()
    public resultList = [];

    @Output()
    public onCancel: EventEmitter<any> = new EventEmitter();

    @Output()
    public onValidate: EventEmitter<any> = new EventEmitter();

    @Output()
    public onDelete: EventEmitter<any> = new EventEmitter();

    public items: Array<MenuItem>;

    constructor(private api: ApiV6Service, protected _messageService: MessagesService) {
    }

    ngOnInit() {
    }

    validate(request) {
        // this.displayWait = true;
        // this.loadingMessage = 'Enregistrement en cours';
        // // id de la requête forcé à 0 : création
        // request.entete.id = 0;
        // this.api.UpdateRequestValue(request.entete, request.detail).subscribe(
        //     (success) => {
        //         this.onValidate.emit({ data: success, duplicate: false });
        //     },
        //     (error) => {
        //         console.log('AddRequestsComponent updateRequest error', error);
        //         this._messageService.add({
        //             severity: 'error',
        //             sticky: true,
        //             summary: 'Message',
        //             detail: 'La mise à jour a échoué',
        //         });
        //         this.displayWait = false;
        //     },
        //     () => {
        //         this.displayWait = false;
        //     }
        // );
    }

    cancel() {
        this.onCancel.emit({ id: null });
    }
}
